import { render, staticRenderFns } from "./RegistPlace.vue?vue&type=template&id=c21697f8&scoped=true&"
import script from "./RegistPlace.vue?vue&type=script&lang=js&"
export * from "./RegistPlace.vue?vue&type=script&lang=js&"
import style0 from "./RegistPlace.vue?vue&type=style&index=0&id=c21697f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21697f8",
  null
  
)

export default component.exports